/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AptosMultiChartCountInfo } from './AptosMultiChartCountInfo';

export type AptosHomeTrxMultiChartInfo = {
    DAVGTCT: string;
    DAVGUCT: string;
    HTP: AptosHomeTrxMultiChartInfo.HTP;
    CNTLIST: Array<AptosMultiChartCountInfo>;
};

export namespace AptosHomeTrxMultiChartInfo {

    export enum HTP {
        DAY = 'DAY',
        WEEK = 'WEEK',
        MONTH = 'MONTH',
        QUARTER = 'QUARTER',
    }


}

